export default {
  name: "People",

  api: {
    person: {
      firstNameLastName: {
        orRequired: "The person needs a name",
      },
    },
  },
}
